import axios from 'axios'
import {AuthModel, UserClaims, UserModel} from './_models'
import {useAuth} from './Auth'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'

const API_URL = process.env.REACT_APP_API_URL
//const API_URL2 = process.env.REACT_APP_API_URL2

//New-Token Kontrolü
/*axios.interceptors.response.use(
  (response) => {
    console.log(response)
    if (response.headers['new-token']) {
      const {saveAuth} = useAuth()
      const newToken = response.headers['new-token']
      // newToken değerini kullan veya işle
      const auth = {
        api_token: String(newToken),
        refreshToken: String(newToken),
      }
      saveAuth(auth)
      // Axios istek yapılandırmasını güncelle
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
      axios.defaults.headers.common['Accept-Language'] = useLang()
    }
    return response
  },
  (error) => {
    console.log(error)
    const {logout} = useAuth()
    if (error.response && error.response.status === 401) {
      // API token geçersiz veya süresi dolmuş durumda
      logout()
    }
    return Promise.reject(error)
  }
)*/

//Auth
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/User/getuserbytoken`
export const LOGIN_URL = `${API_URL}/Auth/login`
export const REGISTER_URL = `${API_URL}/Auth/signup`
export const REQUEST_PASSWORD_URL = `${API_URL}/Auth/forgottenpassword`
export const VERIFY_EMAIL = `${API_URL}/Auth/verifyemail`
export const CHANGE_PASSWORD = `${API_URL}/Auth/changepassword`
export const CHANGE_PASSWORD_FORGETTEN = `${API_URL}/Auth/changepasswordforgotten`

//User
export const UPDATE_BY_USER = `${API_URL}/User/UpdateByUser`
export const GET_LIST_USERS = `${API_URL}/User/listusers`
export const GET_LIST_USERS_BY_ID = `${API_URL}/User/getuserbyid`
export const ADD_USER = `${API_URL}/User/createuser`
export const UPDATE_USER = `${API_URL}/User/updateuser`
export const DELETE_USER = `${API_URL}/User/deleteuser`
export const ADD_USER_CLAIM = `${API_URL}/User/addclaimforuser`
export const DELETE_USER_CLAIM = `${API_URL}/User/deleteclaimforuserbyid`
export const LIST_USER_CLAIM = `${API_URL}/User/listuserclaim`
export const GET_USER_UNIT = `${API_URL}/User/getuserauthorizedunit`
export const ADD_USER_UNIT = `${API_URL}/User/adduserauthorizedunit`
export const DELETE_USER_UNIT = `${API_URL}/User/deleteuserauthorizedunit`
export const LIST_CLAIMS = `${API_URL}/User/listclaims`
export const LIST_USER_CLAIMS = `${API_URL}/User/listuserclaim`
export const LIST_USER_UNIT = `${API_URL}/User/listuserauthorizedunit`

//Dictionary
export const LIST_DEVICE_GROUPS = `${API_URL}/Gnl/listdictionary`
export const SAVE_DEVICE_GT = `${API_URL}/Gnl/savedictionary`
export const DELETE_DEVICE_GT = `${API_URL}/Gnl/deletedictionary`

//Device
export const LIST_DEVICE = `${API_URL}/Device/listdevice`
export const SAVE_DEVICE = `${API_URL}/Device/savedevice`
export const GET_DEVICE = `${API_URL}/Device/getdevicebyid`
export const DELETE_DEVICE = `${API_URL}/Device/deletedevice`
export const SAVE_DEVICE_SHADOW = `${API_URL}/Device/savedeviceshadow`
export const LIST_DEVICE_SHADOW = `${API_URL}/Device/listdeviceshadow`
export const DELETE_DEVICE_SHADOW = `${API_URL}/Device/deletedeviceshadow`
export const SAVE_DEVICE_TYPE = `${API_URL}/Device/savedevicetypes`
export const LIST_DEVICE_TYPE = `${API_URL}/Device/listdevicetypes`
export const LIST_DEVICE_BY_TYPE = `${API_URL}/Device/listdevicebytypes`
export const DELETE_DEVICE_TYPE = `${API_URL}/Device/deletedevicetypes`
export const SAVE_DEVICE_GROUP = `${API_URL}/Device/savedevicegroups`
export const LIST_DEVICE_GROUP = `${API_URL}/Device/listdevicegroups`
export const LIST_DEVICE_BY_GROUP = `${API_URL}/Device/listdevicebygroups`
export const DELETE_DEVICE_GROUP = `${API_URL}/Device/deletedevicegroups`
export const SAVE_DEVICE_USER = `${API_URL}/Device/savedeviceusers`
export const LIST_DEVICE_USER = `${API_URL}/Home/listdeviceusers`
export const DELETE_DEVICE_USER = `${API_URL}/Device/deletedeviceusers`

//Experiment
export const LIST_EXPERIMENT = `${API_URL}/Experiment/listexperiment`
export const LIST_EXPERIMENT_CATEGORYBYID = `${API_URL}/Experiment/listbycategoryid`
export const GET_EXPERIMENT = `${API_URL}/Experiment/getexperimentbyid`
export const SAVE_EXPERIMENT = `${API_URL}/Experiment/saveexperiment`
export const DELETE_EXPERIMENT = `${API_URL}/Experiment/deleteexperiment`
export const LIST_EXPERIMENT_CATEGORY = `${API_URL}/Experiment/listexperimentcategory`
export const SAVE_EXPERIMENT_CATEGORY = `${API_URL}/Experiment/saveexperimentcategory`
export const DELETE_EXPERIMENT_CATEGORY = `${API_URL}/Experiment/deleteexperimentcategorybyid`
export const SAVE_EXPERIMENT_TYPE = `${API_URL}/Experiment/saveexperimenttypes`
export const LIST_EXPERIMENT_TYPE = `${API_URL}/Experiment/listexperimenttypes`
export const DELETE_EXPERIMENT_TYPE = `${API_URL}/Experiment/deleteexperimenttypesbyid`

//Circuit
export const LIST_CIRCUIT = `${API_URL}/Experiment/listcircuit`
export const GET_CIRCUIT = `${API_URL}/Experiment/getcircuitbyid`
export const SAVE_CIRCUIT = `${API_URL}/Experiment/savecircuit`
export const DELETE_CIRCUIT = `${API_URL}/Experiment/deletecircuit`

//Attribute
export const LIST_ATTRIBUTE = `${API_URL}/Experiment/listattribute`
export const SAVE_ATTRIBUTE = `${API_URL}/Experiment/saveattribute`
export const DELETE_ATTRIBUTE = `${API_URL}/Experiment/deleteattribute`

//Category
export const LIST_CATEGORY = `${API_URL}/Category/listcategory`
export const LIST_CATEGORY_TREE = `${API_URL}/Category/listcategorytree`
export const SAVE_CATEGORY = `${API_URL}/Category/savecategory`
export const DELETE_CATEGORY = `${API_URL}/Category/deletecategorybyid`

//Content
export const LIST_CONTENT = `${API_URL}/Content/listcontent`
export const LIST_CONTENT_BY_CATEGORY_ID = `${API_URL}/Content/listcontentbycategoryid`
export const SAVE_CONTENT = `${API_URL}/Content/savecontent`
export const DELETE_CONTENT = `${API_URL}/Content/deletecontentbyid`
export const GET_CONTENT_BY_ID = `${API_URL}/Content/getcontentbyid`
export const LIST_CONTENT_CATEGORY = `${API_URL}/Content/listcontentcategory`
export const SAVE_CONTENT_CATEGORY = `${API_URL}/Content/savecontentcategory`
export const DELETE_CONTENT_CATEGORY = `${API_URL}/Content/deletecontentcategorybyid`

//File
export const UPLOAD_FILE = `${API_URL}/File/uploadfile`
export const GET_FILE = API_URL

//Unit
export const LIST_UNIT = `${API_URL}/Unit/listunit`
export const LIST_UNIT_TREE = `${API_URL}/Unit/listunittree`
export const SAVE_UNIT = `${API_URL}/Unit/saveunit`
export const DELETE_UNIT = `${API_URL}/Unit/deleteunitbyid`

// Reference Code
export const GENERATERE_REFERENCES_CODE_UNIT = `${API_URL}/ReferencesCode/generatereferencescode`
export const LIST_REFERENCES_CODE = `${API_URL}/ReferencesCode/listreferencescode`
export const DELETE_REFERENCES_CODE = `${API_URL}/ReferencesCode/deletereferencescode`

//SMR Topic
export const LIST_TOPIC = `${API_URL}/SmrTopic/listtopic`
export const GET_TOPIC_BY_ID = `${API_URL}/SmrTopic/gettopicbyid`
export const SAVE_TOPIC = `${API_URL}/SmrTopic/savetopic`
export const DELETE_TOPIC = `${API_URL}/SmrTopic/deletetopic`

//SMR Message
export const LIST_MESSAGE = `${API_URL}/SmrMessage/listmessage`
export const GET_MESSAGE_BY_ID = `${API_URL}/SmrMessage/getmessagebyid`
export const GET_MESSAGE_BY_CRITERIA = `${API_URL}/SmrMessage/getmessagebycriteria`
export const SAVE_MESSAGE = `${API_URL}/SmrMessage/savemessage`
export const DELETE_MESSAGE = `${API_URL}/SmrMessage/deletemessage`

//AWS
export const PUBLISH_MINILAB_DATA = `${API_URL}/Aws/publishminilabdata`
export const SUBSCRIBE_MINILAB_DATA = `${API_URL}/Aws/subscribeminilabdata`

//Home
export const HOME_LIST_CATEGORY_TREE = `${API_URL}/Home/listcategorytree`
export const HOME_LIST_CATEGORY = `${API_URL}/Home/listcategory`
export const HOME_LIST_DEVICE_USERS_BY_TYPES = `${API_URL}/Home/listdeviceusersbytypes`
export const HOME_LIST_CONTENT_BY_CATEGORY_ID = `${API_URL}/Home/listcontentbycategoryid`
export const HOME_LIST_EXPERIMENT = `${API_URL}/Home/listexperiment`
export const HOME_LIST_EXPERIMENT_BY_CATEGORY_ID = `${API_URL}/Home/lisexperimenttbycategoryid`
export const HOME_LIST_MESSAGE = `${API_URL}/Home/listmessage`
export const HOME_LIST_TOPIC = `${API_URL}/Home/listtopic`
export const HOME_PUBLISH_MINILAB_DATA = `${API_URL}/Home/publishminilabdata`
export const HOME_SUBSCRIBE_MINILAB_DATA = `${API_URL}/Home/subscribeminilabdata`
export const HOME_SUBSCRIBE_MINILAB_STRING_DATA = `${API_URL}/Home/subscribeminilabstringdata`
export const HOME_SAVE_CONTENT_STATISTICS = `${API_URL}/Home/savecontentstatistics`
export const HOME_LIST_CONTENT_STATISTICS = `${API_URL}/Home/listcontentstatistics`
export const HOME_LIST_AUTHORIZED_USERS = `${API_URL}/Home/listauthorizedusers`

//Home Ekstra
export const HOME_PUBLISH_MINILAB_DATA_MULTI = `${API_URL}/Home/publishminilabdatamulti`
export const HOME_SUBSCRIBE_MINILAB_DATA_MULTI = `${API_URL}/Home/subscribeminilabdatamulti`
export const HOME_SUBSCRIBE_MINILAB_STRING_DATA_MULTI = `${API_URL}/Home/subscribeminilabstringdatamulti`
export const HOME_LIST_MESSAGE_MULTI = `${API_URL}/Home/listmessagemulti`
export const HOME_LIST_EXPERIMENT_LOG = `${API_URL}/Home/listexperimentlog`
export const SETUP_STEPMOTOR = `${API_URL}/Home/setupstepmotor`

// Server should return AuthModel
export function login(email: string, password: string, token: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
    GoogleCaptchaToken: token,
  })
}

export function verifyemail(email: string, activateGuid: string) {
  return axios.post<AuthModel>(VERIFY_EMAIL, {
    email,
    activateGuid,
  })
}

// Server should return AuthModel
export function register(
  firstname: string,
  lastname: string,
  email: string,
  password: string,
  password_confirmation: string,
  referencesCode: string
) {
  return axios.post(REGISTER_URL, {
    firstName: firstname,
    lastName: lastname,
    email,
    password,
    rePassword: password_confirmation,
    referencesCode,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function forgettenPassword(email: string) {
  return axios.get<{result: boolean}>(REQUEST_PASSWORD_URL + `/${email}`)
}

//Change Password
export function changePassword(password: string, rePassword: string, token: string) {
  return axios.post(CHANGE_PASSWORD, {password, rePassword})
}

//Change Password Forgetten
export function changePasswordForgetten(
  email: string,
  password: string,
  rePassword: string,
  activateGuid: string
) {
  return axios.post(CHANGE_PASSWORD_FORGETTEN, {email, password, rePassword, activateGuid})
}

//GetUserByToken
export function getUserByToken(token: string) {
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {})
}

//UpdateByUser
export function updateByUser(
  token: string,
  id: number,
  firstName: string,
  lastName: string,
  email: string,
  telefon: string,
  isActive: boolean,
  isActivated: boolean
) {
  return axios.post<UserModel>(UPDATE_BY_USER, {
    id,
    firstName,
    lastName,
    email,
    telefon,
    isActive,
    isActivated,
  })
}

//Get Users List
export function getUserLists(token: string) {
  return axios.post(GET_LIST_USERS, {
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    unicId: '',
    ldapUser: '',
    telefon: '',
  })
}

//Get Users List
export function getUserList(firstName, lastName, claimId, unitId, email, isActivated, isActive) {
  return axios.post(GET_LIST_USERS, {
    id: 0,
    firstName,
    lastName,
    email,
    isActivated,
    isActive,
    claimId,
    unitId,
  })
}

//Add User
export function addUser(
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  isActivated: boolean,
  telefon: string
) {
  return axios.post(ADD_USER, {
    id: 0,
    firstName,
    lastName,
    email,
    password,
    isActivated,
    telefon,
  })
}

// Update User
export function updateUser(
  id: number,
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  isActivated: boolean,
  telefon: string,
  isActive: boolean,
  activateGuid: string
) {
  return axios.post(UPDATE_USER, {
    id,
    firstName,
    lastName,
    email,
    password,
    isActivated,
    telefon,
    isActive,
    activateGuid,
  })
}

//Delete User
export function deleteUser(id: number) {
  return axios.delete(`${DELETE_USER}/${id}`)
}

// Add Claim User
export function addClaimUser(userId: number, operationClaimId: number) {
  return axios.post(ADD_USER_CLAIM, {id: 0, userId, operationClaimId})
}

//Delete Claim Usre
export function deleteClaimUser(id: number) {
  return axios.delete(`${DELETE_USER_CLAIM}/${id}`)
}

//List User Claim
export function listUserClaim(userId: number) {
  return axios.get(`${LIST_USER_CLAIM}/${userId}`)
}

// Get User Unit
export function getUserUnit(userClaimId: number, dilCode: string) {
  return axios.get(GET_USER_UNIT + `/${userClaimId}/${dilCode}`)
}

// ADD User Unit
export function addUserUnit(userId: number, unitId: number) {
  return axios.post(ADD_USER_UNIT, {userId, unitId})
}

// Delete User Unit
export function deleteUserUnit(userId: number, unitId: number) {
  return axios.delete(`${DELETE_USER_UNIT}`, {
    data: {
      userId,
      unitId,
    },
  })
}

//List Device Group
export function listDeviceGroup(
  Type: number,
  DilId: string,
  Name: string,
  Description: string,
  IsActive: boolean
) {
  return axios.post(LIST_DEVICE_GROUPS, {
    Type,
    DilId,
    Name,
    Description,
    IsActive,
  })
}

//List Device By Group
export function listDeviceByGroup(id: number, dictionaryId: number) {
  return axios.post(LIST_DEVICE_BY_GROUP, {id, dictionaryId})
}

//Update Device Group
export function updateDeviceGroup(
  Id: number,
  Type: number,
  DilId: string,
  Name: string,
  Description: string,
  IsActive: boolean
) {
  return axios.post(SAVE_DEVICE_GT, {
    Id,
    Type,
    DilId,
    Name,
    Description,
    IsActive,
  })
}

//Craete Device Group
export function createDeviceGroup(
  Type: number,
  DilId: string,
  Name: string,
  Description: string,
  IsActive: boolean
) {
  return axios.post(SAVE_DEVICE_GT, {
    Type,
    DilId,
    Name,
    Description,
    IsActive,
  })
}

//Delete Device Group
export function deleteDeviceGroup(IdList: Array<Number>) {
  return axios.delete(DELETE_DEVICE_GT, {data: IdList})
}

//List Device By Types
export function listDeviceByTypes(id: number, dictionaryId: number) {
  return axios.post(LIST_DEVICE_BY_TYPE, {id, dictionaryId})
}

//Craete Device Group
export function createDeviceType(
  Type: number,
  DilId: string,
  Name: string,
  Description: string,
  IsActive: boolean
) {
  return axios.post(SAVE_DEVICE_GT, {
    Type,
    DilId,
    Name,
    Description,
    IsActive,
  })
}

//Update Device Type
export function updateDeviceType(
  Id: number,
  Type: number,
  DilId: string,
  Name: string,
  Description: string,
  IsActive: boolean
) {
  return axios.post(SAVE_DEVICE_GT, {
    Id,
    Type,
    DilId,
    Name,
    Description,
    IsActive,
  })
}

//Delete Device Type
export function deleteDeviceType(IdList: Array<Number>) {
  return axios.delete(DELETE_DEVICE_GT, {data: IdList})
}

//Device List
export function listDevice(Id: number, SerialNumber: string, ThingName: string, EndPoint: string) {
  return axios.post(LIST_DEVICE, {
    Id,
    SerialNumber,
    ThingName,
    EndPoint,
  })
}

// Get Device id List
export function getDevice(Id: number) {
  return axios.get(`${GET_DEVICE}/${Id}`)
}

//Device Save
export function saveDevice(
  id: number,
  serialNumber: string,
  thingName: string,
  endPoint: string,
  IsActive: boolean,
  subDeviceId: number
) {
  return axios.post(SAVE_DEVICE, {
    id,
    serialNumber,
    thingName,
    endPoint,
    IsActive,
    subDeviceId,
  })
}

//Update Device
export function updateDevice(
  id: number,
  serialNumber: string,
  thingName: string,
  endPoint: string,
  IsActive: boolean,
  subDeviceId: number
) {
  return axios.post(SAVE_DEVICE, {
    id,
    serialNumber,
    thingName,
    endPoint,
    IsActive,
    subDeviceId,
  })
}

//Delete Device
export function deleteDevice(IdList: Array<Number>) {
  return axios.delete(DELETE_DEVICE, {data: IdList})
}

//Save Device Shadow
export function saveDeviceShadow(
  deviceId: number,
  shadowType: number,
  shadowName: string,
  shadowUrl: string
) {
  return axios.post(SAVE_DEVICE_SHADOW, {
    deviceId,
    shadowType,
    shadowName,
    shadowUrl,
  })
}

//Update Device Shadow
export function updateDeviceShadow(
  id: number,
  deviceId: number,
  shadowType: number,
  shadowName: string,
  shadowUrl: string
) {
  return axios.post(SAVE_DEVICE_SHADOW, {
    id,
    deviceId,
    shadowType,
    shadowName,
    shadowUrl,
  })
}

//List Deviec Shadow
export function DeviceListShadow(deviceId: number) {
  return axios.post(LIST_DEVICE_SHADOW, {deviceId})
}

//Delete Device Shadow
export function deleteDeviceShadow(IdList: Array<Number>) {
  return axios.delete(DELETE_DEVICE_SHADOW, {data: IdList})
}

//Save Device Type
export function saveDeviceType(deviceId: number, dictionaryId: number) {
  return axios.post(SAVE_DEVICE_TYPE, {deviceId, dictionaryId})
}

//List Device Type
export function DeviceListType(deviceId: number) {
  return axios.post(LIST_DEVICE_TYPE, {deviceId})
}

//Delete Device Type
export function DeviceDeleteType(IdList: Array<Number>) {
  return axios.delete(DELETE_DEVICE_TYPE, {data: IdList})
}

//Save Device Group
export function saveDeviceGroup(deviceId: number, dictionaryId: number) {
  return axios.post(SAVE_DEVICE_GROUP, {deviceId, dictionaryId})
}

//List Device Group
export function DeviceListGroup(deviceId: number) {
  return axios.post(LIST_DEVICE_GROUP, {deviceId})
}

//Delete Device Type
export function DeviceDeleteGroup(IdList: Array<Number>) {
  return axios.delete(DELETE_DEVICE_GROUP, {data: IdList})
}

//Save Device User
export function saveDeviceUser(deviceId: number, userId: number) {
  return axios.post(SAVE_DEVICE_USER, {deviceId, userId})
}

//List Device User
export function DeviceListUser(deviceId: number) {
  return axios.post(LIST_DEVICE_USER, {deviceId})
}

//Delete Device User
export function DeviceDeleteUser(IdList: Array<Number>) {
  return axios.delete(DELETE_DEVICE_USER, {data: IdList})
}

//List User Device
export function listDeviceUserById(userId: number) {
  return axios.post(LIST_DEVICE_USER, {userId})
}

//List Experiment
export function listExperiment(
  id: number,
  code: string,
  name: string,
  dilCode: string,
  deviceCode: string
) {
  return axios.post(LIST_EXPERIMENT, {id, code, name, dilCode, deviceCode})
}

//List Experiment Category By Id
export function listExperimentCategoryById(categoryId: number, dilCode: string) {
  return axios.post(LIST_EXPERIMENT_CATEGORYBYID, {categoryId, dilCode})
}

//GET BY ID EXPERIMENT
export function getExperiment(id: number, dilCode: string) {
  return axios.get(`${GET_EXPERIMENT}/${id}/${dilCode}`)
}

//List Experiment Type
export function listExperimentType(
  experimentId: number,
  dictionaryId: number,
  experimentTypeName: string,
  dilCode: string
) {
  return axios.post(LIST_EXPERIMENT_TYPE, {experimentId, dictionaryId, experimentTypeName, dilCode})
}

//Save Experiment
export function saveExperiment(
  id: number,
  code: string,
  name: string,
  dilCode: string,
  deviceCode: string,
  description: string
) {
  return axios.post(SAVE_EXPERIMENT, {id, code, name, dilCode, deviceCode, description})
}

//Update Experiment
export function updateExperiment(
  id: number,
  code: string,
  name: string,
  dilCode: string,
  deviceCode: string,
  description: string
) {
  return axios.post(SAVE_EXPERIMENT, {id, code, name, dilCode, deviceCode, description})
}

//Delete Experiment
export function deleteExperimnent(IdList: Array<Number>) {
  return axios.delete(DELETE_EXPERIMENT, {data: IdList})
}

//List Experiment Category
export function listExperimentCategory(experimentID: number, categoryId: number) {
  return axios.post(LIST_EXPERIMENT_CATEGORY, {experimentID, categoryId})
}

//Save Experiment Category
export function saveExperimentCategory(
  ExperimentID: number,
  CategoryId: number
  /*  ExperimentTitle: string,
  DilCode: string,
  HiyerarsiMap: string,
  NodeAd: string*/
) {
  return axios.post(SAVE_EXPERIMENT_CATEGORY, {
    ExperimentID,
    CategoryId,
    /*ExperimentTitle,
    DilCode,
    HiyerarsiMap,
    NodeAd,*/
  })
}

//DeleteExperiment Category
export function deleteExperimentCategory(IdList: Array<Number>) {
  return axios.delete(DELETE_EXPERIMENT_CATEGORY, {data: IdList})
}

//Save Experiment Type
export function saveExperimentType(
  experimentId: number,
  dictionaryId: number,
  experimentTypeName: string,
  dilCode: string
) {
  return axios.post(SAVE_EXPERIMENT_TYPE, {experimentId, dictionaryId, experimentTypeName, dilCode})
}

//Delete Experiment Type
export function deleteExperimentType(
  experimentId: number,
  dictionaryId: number,
  experimentTypeName: string,
  dilCode: string
) {
  return axios.delete(DELETE_EXPERIMENT_TYPE, {
    data: [{experimentId, dictionaryId, experimentTypeName, dilCode}],
  })
}

//List Circuit
export function listCircuit(
  id: number,
  experimentId: number,
  code: string,
  inputType: number,
  IOType: number,
  dilCode: string,
  name: string,
  AttiributeDTOs: Array<any>
) {
  return axios.post(LIST_CIRCUIT, {
    id,
    experimentId,
    code,
    inputType,
    IOType,
    dilCode,
    name,
    AttiributeDTOs,
  })
}

//GET BY ID CIRCUIT
export function getCircuit(id: number, dilCode: string) {
  return axios.get(`${GET_CIRCUIT}/${id}/${dilCode}`)
}

//Save Circuit
export function saveCircuit(
  experimentId: number,
  code: string,
  inputType: number,
  IOType: number,
  dilCode: string,
  name: string,
  description: string
) {
  return axios.post(SAVE_CIRCUIT, {
    experimentId,
    code,
    inputType,
    IOType,
    dilCode,
    name,
    description,
    attiributeDTOs: [],
  })
}

//Update Circuit
export function updateCircuit(
  id: number,
  experimentId: number,
  code: string,
  inputType: number,
  IOType: number,
  dilCode: string,
  name: string,
  description: string
) {
  return axios.post(SAVE_CIRCUIT, {
    id,
    experimentId,
    code,
    inputType,
    IOType,
    dilCode,
    name,
    description,
    attiributeDTOs: [],
  })
}

//Delete Circuit
export function deleteCircuit(IdList: Array<Number>) {
  return axios.delete(DELETE_CIRCUIT, {data: IdList})
}

//List Attribute
export function listAttribute(
  id: number,
  circuitId: number,
  key: string,
  value: string,
  dilCode: string,
  description: string
) {
  return axios.post(LIST_ATTRIBUTE, {
    id,
    circuitId,
    key,
    value,
    dilCode,
    description,
  })
}

//Save Attribute
export function saveAttribute(
  circuitId: number,
  key: string,
  value: string,
  dilCode: string,
  description: string,
  maxValue: number
) {
  return axios.post(SAVE_ATTRIBUTE, {
    circuitId,
    key,
    value,
    dilCode,
    description,
    maxValue,
  })
}

//Update Attribute
export function updateAttribute(
  id: number,
  circuitId: number,
  key: string,
  value: string,
  dilCode: string,
  description: string,
  maxValue: number
) {
  return axios.post(SAVE_ATTRIBUTE, {
    id,
    circuitId,
    key,
    value,
    dilCode,
    description,
    maxValue,
  })
}

//Delete Attribute
export function deleteAttribute(IdList: Array<Number>) {
  return axios.delete(DELETE_ATTRIBUTE, {data: IdList})
}

//List Category
export function listCategory(
  id: number,
  parentId: number,
  hiyerarsiMap: string,
  dilCode: string,
  nodeAd: string,
  description: string
) {
  return axios.post(LIST_CATEGORY, {
    id,
    parentId,
    hiyerarsiMap,
    dilCode,
    nodeAd,
    description,
  })
}

//List Category Tree
export function listCategoryTree(
  isActive: boolean,
  id: number,
  parentId: number,
  hiyerarsiMap: string,
  dilCode: string,
  nodeAd: string,
  description: string
) {
  return axios.post(LIST_CATEGORY_TREE, {
    isActive,
    id,
    parentId,
    hiyerarsiMap,
    dilCode,
    nodeAd,
    description,
  })
}

//Save Category
export function saveCategory(
  id: number,
  isActive: boolean,
  parentId: number,
  hiyerarsiMap: string,
  dilCode: string,
  nodeAd: string,
  description: string
) {
  return axios.post(SAVE_CATEGORY, {
    id,
    isActive,
    parentId,
    hiyerarsiMap,
    dilCode,
    nodeAd,
    description,
  })
}

//Delete Category
export function deleteCategory(IdList: Array<Number>) {
  return axios.delete(DELETE_CATEGORY, {data: IdList})
}

//List Content
export function listContent(id: number, metadata: string, dilCode: string, contentTitle: string) {
  return axios.post(LIST_CONTENT, {
    id,
    metadata,
    dilCode,
    contentTitle,
  })
}

//List Content Category By Id
export function listContentByCategoryId(categoryId: number, dilCode: string) {
  return axios.post(LIST_CONTENT_BY_CATEGORY_ID, {
    categoryId,
    dilCode,
  })
}

//Save Content
/*export function saveContent(
  id: number,
  contentType: number,
  releaseDate: string,
  metadata: string,
  dilCode: string,
  contentTitle: string,
  contentText: string,
  spot: string,

) {
  return axios.post(SAVE_CONTENT, {
    id,
    contentType,
    releaseDate,
    metadata,
    dilCode,
    contentTitle,
    contentText,
    spot,
  })
}*/

export function saveContent(formData: FormData) {
  return axios.post(SAVE_CONTENT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

//Delete Content
export function deleteContent(IdList: Array<Number>) {
  return axios.delete(DELETE_CONTENT, {data: IdList})
}

// Get Contet id
export function getContent(Id: number, dilcode: string) {
  return axios.get(`${GET_CONTENT_BY_ID}/${Id}/${dilcode}`)
}

//List Content Category
export function listContentCategory(contentID: number, categoryId: number) {
  return axios.post(LIST_CONTENT_CATEGORY, {
    contentID,
    categoryId,
  })
}

//Save Content Category
export function saveContentCategory(contentID: number, categoryId: number) {
  return axios.post(SAVE_CONTENT_CATEGORY, {
    contentID,
    categoryId,
  })
}

//Delete Content Category
export function deleteContentCategory(IdList: Array<Number>) {
  return axios.delete(DELETE_CONTENT_CATEGORY, {data: IdList})
}

//List Unit
export function listUnit(id: number, parentId: number) {
  return axios.post(LIST_UNIT, {
    id,
    parentId,
  })
}

//List Unit Tree
export function listUnitTree(id: number, parentId: number) {
  return axios.post(LIST_UNIT_TREE, {
    id,
    parentId,
  })
}

//Save Unit
export function saveUnit(
  id: number,
  parentId: number,
  hiyerarsiMap: string,
  dilCode: string,
  name: string,
  UsersNumberLimit: number,
  description: string
) {
  return axios.post(SAVE_UNIT, {
    id,
    parentId,
    hiyerarsiMap,
    dilCode,
    name,
    UsersNumberLimit,
    description,
  })
}

//Delete Unit
export function deleteUnit(IdList: Array<Number>) {
  return axios.delete(DELETE_UNIT, {data: IdList})
}

//List Topic
export function listTopic(id: number) {
  return axios.post(LIST_TOPIC, {
    id,
  })
}

//Save Topic
export function saveTopic(
  id: number,
  name: string,
  description: string,
  command: string,
  icon: string,
  measurementUnit: string,
  dilCode: string,
  token: string
) {
  return axios.post(
    SAVE_TOPIC,
    {
      id,
      name,
      description,
      command,
      icon,
      measurementUnit,
      dilCode,
    }
    /* {
      headers: {Authorization: `Bearer ${token}`},
    }*/
  )
}

// Get Topic By id
export function getTopicById(Id: number, dilcode: string) {
  return axios.get(`${GET_TOPIC_BY_ID}/${Id}/${dilcode}`)
}

//Delete Topic
export function deleteTopic(IdList: Array<Number>) {
  return axios.delete(DELETE_TOPIC, {data: IdList})
}

//List Message
export function listMessage(id: number, TopicId: number, deviceId: number) {
  return axios.post(LIST_MESSAGE, {
    id,
    TopicId,
    deviceId,
  })
}

//Save Message
export function saveMessage(id: number, deviceId: number, topicId: number, payload: string) {
  return axios.post(SAVE_MESSAGE, {
    id,
    deviceId,
    topicId,
    payload,
  })
}

//Delete Topic
export function deleteMessage(IdList: Array<Number>) {
  return axios.delete(DELETE_MESSAGE, {data: IdList})
}

//AWS Publish Data
export function awsPublishData(
  deviceId: number,
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(PUBLISH_MINILAB_DATA, {
    deviceId,
    miniLabRootValueDTO,
  })
}

//Aws Subscribe Data
export function awsSubscribeData(
  deviceId: number,
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(SUBSCRIBE_MINILAB_DATA, {
    deviceId,
    miniLabRootValueDTO,
  })
}

//Home List User Device
export function homeListDeviceUserById(userId: number) {
  return axios.post(HOME_LIST_DEVICE_USERS_BY_TYPES, {userId})
}

//AWS Home Publish Data
/*export function awsHomePublishData(
  deviceId: number,
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(HOME_PUBLISH_MINILAB_DATA, {
    deviceId,
    miniLabRootValueDTO,
  })
}*/

// Yeni 23.09.2023 -AWS Home Publish Data
export function awsHomePublishData(
  deviceId: number,
  experimentId: number,
  circuitId: number,
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(HOME_PUBLISH_MINILAB_DATA, {
    deviceId,
    experimentId,
    circuitId,
    miniLabRootValueDTO,
  })
}

//Aws Home Subscribe Data
export function awsHomeSubscribeData(
  experimentId: number,
  circuitId: number,
  deviceId: number,
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(HOME_SUBSCRIBE_MINILAB_DATA, {
    experimentId,
    circuitId,
    deviceId,
    miniLabRootValueDTO,
  })
}

//Aws Home Subscribe String Data
export function awsHomeSubscribeStringData(
  experimentId: number,
  circuitId: number,
  deviceId: number,
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(HOME_SUBSCRIBE_MINILAB_STRING_DATA, {
    experimentId,
    circuitId,
    deviceId,
    miniLabRootValueDTO,
  })
}

export function getListExperimentByCategoryId(
  categoryId: number,
  dilCode: string,
  deviceId: number[]
) {
  return axios.post(HOME_LIST_EXPERIMENT_BY_CATEGORY_ID, {
    categoryId,
    dilCode,
    deviceId, // Yeni 31.01.2024
  })
}

//List Content Category By Id
export function getListContentByCategoryId(
  categoryId: number,
  dilCode: string
  // deviceId: number[]
) {
  return axios.post(HOME_LIST_CONTENT_BY_CATEGORY_ID, {
    categoryId,
    dilCode,
    // deviceId, // Yeni 31.01.2024
  })
}

// Yeni 01.12.23 -AWS Home Publish Data Multi
export function awsHomePublishDataMulti(
  experimentId: number,
  circuitId: number,
  deviceIds: number[],
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(HOME_PUBLISH_MINILAB_DATA_MULTI, {
    experimentId,
    circuitId,
    deviceIds,
    miniLabRootValueDTO,
  })
}

//Aws Home Subscribe Data Multi
export function awsHomeSubscribeDataMulti(
  experimentId: number,
  circuitId: number,
  deviceIds: number[],
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(HOME_SUBSCRIBE_MINILAB_DATA_MULTI, {
    experimentId,
    circuitId,
    deviceIds,
    miniLabRootValueDTO,
  })
}

//Aws Home Subscribe String Data Multi
export function awsHomeSubscribeStringDataMulti(
  experimentId: number,
  circuitId: number,
  deviceIds: number[],
  miniLabRootValueDTO: {device: number; degerlers: number[][]}
) {
  return axios.post(HOME_SUBSCRIBE_MINILAB_STRING_DATA, {
    experimentId,
    circuitId,
    deviceIds,
    miniLabRootValueDTO,
  })
}

export function listMessageMulti(id: number, deviceIds: number[], topicId: number) {
  return axios.post(HOME_LIST_MESSAGE_MULTI, {
    id,
    deviceIds,
    topicId,
  })
}

// Home List Category Tree
export function homeListCategoryTree(
  isActive: boolean,
  id: number,
  parentId: number,
  hiyerarsiMap: string,
  dilCode: string,
  nodeAd: string,
  description: string
) {
  return axios.post(HOME_LIST_CATEGORY_TREE, {
    isActive,
    id,
    parentId,
    hiyerarsiMap,
    dilCode,
    nodeAd,
    description,
  })
}

// Home List Experiment
export function homeListExperiment(
  id: number,
  code: string,
  name: string,
  dilCode: string,
  deviceCode: string
) {
  return axios.post(HOME_LIST_EXPERIMENT, {id, code, name, dilCode, deviceCode})
}

// Home List Experiment Log
export function listExperimentLog(
  id: number,
  experimentId: number,
  circuitId: number,
  deviceId: number,
  userId: number,
  //startDate: Date,
  // finishDate: Date,
  //deviceShadowtype: number,
  dilCode: string
  // reportType: number
) {
  return axios.post(HOME_LIST_EXPERIMENT_LOG, {
    id,
    experimentId,
    circuitId,
    deviceId,
    userId,
    dilCode,
  })
}

// Home Save Content Statistics
export function homeSaveContentStatistics(
  userId: number,
  contentId: number,
  time: Date,
  viewType: number
) {
  return axios.post(HOME_SAVE_CONTENT_STATISTICS, {userId, contentId, time, viewType})
}

// Home List Content Statistics
export function homeListContentStatistics(
  id: number,
  userId: number,
  contentId: number,
  startDate: Date,
  finishDate: Date,
  viewType: number,
  contentType: number,
  dilcode: string
) {
  return axios.post(HOME_LIST_CONTENT_STATISTICS, {
    id,
    userId,
    contentId,
    startDate,
    finishDate,
    viewType,
    contentType,
    dilcode,
  })
}

// Setup Step Motor
export function setupstepmotor(
  DeviceId: number,
  ExperimentId: number,
  PasitionId: number,
  Value: number,
  ReadMode: boolean,
  MotorId: number
) {
  return axios.post(SETUP_STEPMOTOR, {
    DeviceId,
    ExperimentId,
    PasitionId,
    Value,
    ReadMode,
    MotorId,
  })
}

// Reference Code
export function generateReferencesCode(
  id: number,
  code: string,
  expireDate: Date,
  fkId: number,
  referencesType: number,
  userRole: number
) {
  return axios.post(GENERATERE_REFERENCES_CODE_UNIT, {
    id,
    code,
    expireDate,
    fkId,
    referencesType,
    userRole,
  })
}

export function listReferencesCode(userRole: number, referencesType: number) {
  return axios.post(LIST_REFERENCES_CODE, {
    userRole,
    referencesType,
  })
}

export function deleteReferencesCode(id: number) {
  return axios.delete(DELETE_REFERENCES_CODE, {params: {id}})
}

//

export function getListAuthorizedUsers(unitId?: number) {
  if (unitId) {
    return axios.get(HOME_LIST_AUTHORIZED_USERS + `/${unitId}`)
  }
  return axios.get(HOME_LIST_AUTHORIZED_USERS)
}

// List Claims
export function getClaimsList() {
  return axios.get(LIST_CLAIMS)
}

// List User Claims
export function getUserClaimsList(Id: number) {
  return axios.get(`${LIST_USER_CLAIMS}/${Id}`)
}

// Get User By Id
export function getUserById(Id: number) {
  return axios.get(`${GET_LIST_USERS_BY_ID}/${Id}`)
}

// Get User Units
export function getUserUnitList(Id: number, dilCode: string) {
  return axios.get(`${LIST_USER_UNIT}/${Id}/${dilCode}`)
}
